export enum PlaidCustomerStatus {
  Unverified = 'unverified',
  Verified = 'verified',
}
